import { Fragment } from 'react';
import { AuthControl } from '../../pages/authentication/AuthControl';
import { useSession } from '../../shared/lib/useSession';
import { SectionButton } from './Components';
import { PropTypes } from 'prop-types';

export function SideBarCompany({ onBack }) {
    const session = useSession();

    return (
        <Fragment>
            <div role='menu'>
                <a
                    role='button'
                    aria-label='Click to go back'
                    className='title'
                    onClick={() => onBack()}
                >
                    <i
                        aria-label='Click to go back'
                        className='icon-long-arrow-left'
                    ></i>
                    <h5 role='none'>Company</h5>
                </a>

                <AuthControl
                    permissions='company::feedback;company::pulse_settings'
                    authorized={
                        <div className='sub-title'>
                            <h6>Feedback</h6>
                        </div>
                    }
                />
                <AuthControl
                    permissions='company::feedback'
                    authorized={
                        <SectionButton
                            to={'/company/feedback/overview'}
                            icon={'icon-insight-active'}
                            title='Overview'
                        >
                            Overview
                        </SectionButton>
                    }
                />
                <AuthControl
                    permissions='company::feedback;company::pulse_settings'
                    authorized={
                        <SectionButton
                            to={'/company/feedback/pulse'}
                            icon={'icon-pulse'}
                            title='Pulse Surveys'
                        >
                            Pulse Surveys
                        </SectionButton>
                    }
                />
                <AuthControl
                    permissions='company::feedback'
                    authorized={
                        <Fragment>
                            <SectionButton
                                to={'/company/feedback/peer-to-peer'}
                                icon={'icon-peer-active'}
                                title='Peer Feedback'
                            >
                                Peer
                            </SectionButton>
                            <SectionButton
                                to={'/company/feedback/organisation'}
                                icon={'icon-megaphone-active'}
                                title='Employee Voice'
                            >
                                Employee Voice
                            </SectionButton>
                        </Fragment>
                    }
                />

                {session?.isPerformance && (
                    <AuthControl
                        permissions='company::assess'
                        authorized={
                            <Fragment>
                                <div className='sub-title'>
                                    <h6>Assess</h6>
                                </div>
                                <SectionButton
                                    to={'/company/assess'}
                                    icon={'icon-ppr-active'}
                                    title='Assess'
                                >
                                    Assess
                                </SectionButton>
                            </Fragment>
                        }
                    />
                )}
            </div>
        </Fragment>
    );
}

SideBarCompany.propTypes = {
    onBack: PropTypes.func,
};
